module.exports = __webpack_public_path__ + "img/logo.ff0f4409.png";